import { CheckCircle, Plus, Trash } from '@phosphor-icons/react'
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import { v4 as uuidv4 } from 'uuid'
import { TitleLine } from '../../../../components/TitleLine'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { ContextResidents } from '../../../../context/context_residents'
import api from '../../../../services/api'
import {
  AddButtonContainer,
  AddressContainer,
  ButtonContainer,
  ButtonRow,
  Container,
  Divider,
  RemoveButtonContainer,
  Row,
  Section,
  Title,
} from './styles'
import axios from 'axios'
import { userInfo } from 'os'
import { Modal } from '../../../../components/Modal'

interface FormUserDataResidentProps {
  handleModalSave: Dispatch<SetStateAction<boolean>>
  handleModalDisable: Dispatch<SetStateAction<boolean>>
  // handleDataResidentState: Dispatch<SetStateAction<boolean>>
}

type AddressProps = {
  id: string
  id_responsible_base: string
  address: string
  state: string
  city: string
  burgh: string
  zipcode: string
  latitude: number
  longitude: number
}

type VehicleProps = {
  id: string
  vehicle: string
  color: string
  plate: string
  type: string
}

export const FormUserDataResident = ({
  handleModalDisable,
  handleModalSave, // handleDataResidentState,
}: FormUserDataResidentProps) => {
  const { editItem, updateItem, stopEditing } = useContext(ContextResidents)

  const [userData, setUserData] = useState({
    UserInfo: [
      { name: editItem.name, email: editItem.email, phone: editItem.phone },
    ],
  })

  const [tempItem, setTempItem] = useState(editItem)
  const [modalSaveDataResident, setModalSaveDataResident] = useState(false)
  const [modalResidentSuccess, setModalResidentSuccess] = useState(false)
  const [baseList, setBaseList] = useState([])
  const [contractList, setContractList] = useState([])

  useEffect(() => {
    api
      .get('/v1/dashboard/base/list')
      .then((res) => {
        setBaseList(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  useEffect(() => {
    api
      .get('/v1/contract/list')
      .then((res) => {
        setContractList(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const baseOptions = baseList?.map((item) => {
    const id = item.id
    const value = item.base

    return { id, value }
  })

  const contractOptions = contractList?.map((item) => {
    const id = item.id
    const value = item.name

    return { id, value }
  })
  const [addressList, setAddressList] = useState<AddressProps[]>(
    editItem && editItem.Address ? editItem.Address : [],
  )
  const [vehiclesList, setVehiclesList] = useState<VehicleProps[]>(
    editItem && editItem.Vehicle ? editItem.Vehicle : [],
  )

  const phonee = '5522982337097'
  const states = [
    { id: 'AC', value: 'Acre' },
    { id: 'AL', value: 'Alagoas' },
    { id: 'AP', value: 'Amapá' },
    { id: 'AM', value: 'Amazonas' },
    { id: 'BA', value: 'Bahia' },
    { id: 'CE', value: 'Ceará' },
    { id: 'DF', value: 'Distrito Federal' },
    { id: 'ES', value: 'Espírito Santo' },
    { id: 'GO', value: 'Goiás' },
    { id: 'MA', value: 'Maranhão' },
    { id: 'MT', value: 'Mato Grosso' },
    { id: 'MS', value: 'Mato Grosso do Sul' },
    { id: 'MG', value: 'Minas Gerais' },
    { id: 'PA', value: 'Pará' },
    { id: 'PB', value: 'Paraíba' },
    { id: 'PR', value: 'Paraná' },
    { id: 'PE', value: 'Pernambuco' },
    { id: 'PI', value: 'Piauí' },
    { id: 'RJ', value: 'Rio de Janeiro' },
    { id: 'RN', value: 'Rio Grande do Norte' },
    { id: 'RS', value: 'Rio Grande do Sul' },
    { id: 'RO', value: 'Rondônia' },
    { id: 'RR', value: 'Roraima' },
    { id: 'SC', value: 'Santa Catarina' },
    { id: 'SP', value: 'São Paulo' },
    { id: 'SE', value: 'Sergipe' },
    { id: 'TO', value: 'Tocantins' },
  ]

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const disableResident = () => {
    setTempItem((prev) => ({
      ...prev,
      active: false,
    }))
  }

  const handleAddAddress = () => {
    const newAddress = {
      id: uuidv4(),
      id_responsible_base: '',
      address: '',
      state: '',
      city: '',
      burgh: '',
      zipcode: '',
      latitude: 0,
      longitude: 0,
    }
    setAddressList((current) => [...current, newAddress])
  }

  const handleAddVehicles = () => {
    const newVehicle = {
      id: uuidv4(),
      vehicle: '',
      type: '',
      plate: '',
      color: '',
    }
    setVehiclesList((current) => [...current, newVehicle])
  }

  const handleRemoveAddress = (idx) => {
    const item = addressList.at(idx)
    setAddressList(addressList.filter((address) => address.id !== item.id))
    setAddressList((updatedList) => {
      setTempItem((prev) => ({
        ...prev,
        Address: updatedList,
      }))
      return updatedList
    })
  }

  const handleRemoveVehicles = (idx) => {
    const item = vehiclesList.at(idx)
    setVehiclesList(vehiclesList.filter((vehicle) => vehicle.id !== item.id))
    setVehiclesList((updatedList) => {
      setTempItem((prev) => ({
        ...prev,
        Vehicle: updatedList,
      }))
      return updatedList
    })
  }

  const handleCepChange = (index) => async (e) => {
    try {
      const newArray = addressList.map((item, i) => {
        if (index === i) {
          return { ...item, [e.target.name]: e.target.value }
        } else {
          return item
        }
      })

      const cep = newArray[index].zipcode

      let response
      if (cep.length >= 8) {
        response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
      }

      // address: response.data.logradouro,
      // zipcode: response.data.cep,
      // burgh: response.data.bairro,
      // city: response.data.localidade,
      // state: response.data.uf,

      setAddressList(newArray)
      setAddressList((updatedList) => {
        if (response) {
          updatedList[index].address = response.data.logradouro
          updatedList[index].zipcode = response.data.cep
          updatedList[index].burgh = response.data.bairro
          updatedList[index].city = response.data.localidade
          updatedList[index].state = response.data.uf
        }

        setTempItem((prev) => ({
          ...prev,
          UserInfo: {
            ...prev.UserInfo,
            id_base: updatedList[index].id_responsible_base,
          },
          Address: updatedList,
        }))
        console.log(tempItem)
        return updatedList
      })
    } catch (error) {
      console.error('Erro na requisição:', error.message)
    }
  }

  const handleAddressChange = (index) => (e) => {
    const newArray = addressList.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value }
      } else {
        return item
      }
    })
    setAddressList(newArray)
    setAddressList((updatedList) => {
      setTempItem((prev) => ({
        ...prev,
        UserInfo: {
          ...prev.UserInfo,
          id_base: updatedList[0].id_responsible_base,
        },
        Address: updatedList,
      }))
      return updatedList
    })
  }

  const handleVehicleChange = (index) => (e) => {
    const newArray = vehiclesList.map((item, i) => {
      if (index === i) {
        return { ...item, [e.target.name]: e.target.value }
      } else {
        return item
      }
    })
    console.log(newArray)
    setVehiclesList(newArray)
    setTempItem((prev) => ({
      ...prev,
      Vehicle: vehiclesList,
    }))
  }

  const handleInputChange = (field, value) => {
    setTempItem((prevItem) => ({
      ...prevItem,
      [field]: value,
    }))
  }

  const handleUserInfoChange = (field, value) => {
    setTempItem((prevItem) => ({
      ...prevItem,
      UserInfo: {
        ...prevItem.UserInfo,
        [field]: value,
      },
    }))
  }

  const handleContractChange = (value) => {
    setTempItem((prevItem) => ({
      ...prevItem,
      Contract: {
        id: value,
      },
    }))
  }

  const setUpdateItem = () => {
    console.log(tempItem, 'adoliajdlaksjdlaksdjlaks')
    setTempItem((prev) => ({
      ...prev,
      Address: addressList,
    }))
    setTempItem((prev) => ({
      ...prev,
      Vehicle: vehiclesList,
    }))
    updateItem(tempItem)
    // toggleFunction(handleModalSave)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    // Consolidar os dados antes de enviar
    const updatedData = {
      ...userData,
      UserInfo: [...userData.UserInfo],
    }
    setUpdateItem()

    setUserData(updatedData)
    setModalSaveDataResident(true)
    // toggleFunction(handleModalSave)
    // Enviar os dados atualizados
    // sendUpdate(updatedData)
  }

  const sendUpdate = (updatedData) => {
    try {
      const UserInfo = {
        name: updatedData.UserInfo[0].name,
        email: updatedData.UserInfo[0].email,
        phone: updatedData.UserInfo[0].phone.replace(/\D/g, ''),
      }

      const newFormData = new FormData()
      newFormData.append('id', editItem.id)
      newFormData.append('login', editItem.login)
      newFormData.append('active', editItem.active ? 'true' : 'false')
      newFormData.append('UserInfo', JSON.stringify(UserInfo))
      newFormData.append('Address', JSON.stringify(addressList))
      newFormData.append('Vehicle', JSON.stringify(vehiclesList))
      newFormData.append('Contract', JSON.stringify(editItem.Contract))

      console.log('Enviando:', UserInfo)

      api
        .put('/v1/dashboard/residents/update', newFormData)
        .then((res) => {
          console.log('Atualização bem-sucedida:', res.data)
          handlerState(setModalResidentSuccess)
        })
        .catch((err) => {
          console.error('Erro na atualização:', err)
        })
    } catch (error) {
      console.error('Erro no envio:', error)
    }
  }

  const handleEditUserData = (field, value) => {
    setUserData((prevItem) => {
      const updatedUserInfo = [...prevItem.UserInfo]
      updatedUserInfo[0] = {
        ...updatedUserInfo[0],
        [field]: value,
      }

      return {
        ...prevItem,
        UserInfo: updatedUserInfo,
      }
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    // Aplica a máscara completa apenas para o campo de telefone
    // const formattedValue = name === 'phone' ? formatPhoneNumber(value) : value;
    handleEditUserData(name, value)
    // handleEditUserData(name, value)
  }

  const handleChangePhone = (e) => {
    const { name, value } = e.target
    // Aplica a máscara completa apenas para o campo de telefone
    const formattedValue = name === 'phone' ? formatPhoneNumber(value) : value
    handleEditUserData(name, formattedValue)
    // handleEditUserData(name, value)
  }

  const formatPhoneNumber = (phone) => {
    if (!phone) return ''
    const cleaned = phone.replace(/\D/g, '') // Remove caracteres não numéricos
    if (cleaned.length <= 2) {
      return `(${cleaned}`
    }
    if (cleaned.length <= 7) {
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2)}`
    }
    return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(
      7,
      11,
    )}`
  }

  const handlerState = (setValue) => {
    setValue((prev) => !prev)
  }

  // useEffect(() => {
  //   setUserData({
  //     UserInfo: [
  //       {
  //         name: userData.UserInfo[0].name,
  //         email: editItem.email,
  //         phone: editItem.phone,
  //       },
  //     ],
  //   })
  // }, [editItem])

  return (
    <Container onSubmit={handleSubmit}>
      <Section>
        <TitleLine title="Dados do titular" />
        <Input.Root>
          <Input.Label title="Nome do usuário" htmlFor="residentName" />
          <Input.Wrapper>
            <Input.Content
              id="residentName"
              name="name"
              type="text"
              value={userData.UserInfo[0].name || ''}
              onChange={handleChange}
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="E-mail" htmlFor="residentEmail" />
          <Input.Wrapper>
            <Input.Content
              id="residentEmail"
              name="email"
              type="text"
              value={userData.UserInfo[0].email}
              onChange={handleChange}
            />
          </Input.Wrapper>
        </Input.Root>
        <Input.Root>
          <Input.Label title="Telefone" htmlFor="residentPhone" />
          <Input.Wrapper>
            <Input.Content
              id="residentPhone"
              name="phone"
              type="tel"
              mask="telNumber"
              pattern="(\(\d{2}\)\s?\d{5}-\d{4})"
              value={userData.UserInfo[0].phone.replace(
                /^55(\d{2})(\d{5})(\d{4})$/,
                '($1) $2-$3',
              )}
              maxLength={13}
              onChange={handleChangePhone}
            />
          </Input.Wrapper>
        </Input.Root>
      </Section>

      {/* Confirmar edição */}

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="25%"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalSaveDataResident}
        setIsOpenController={() => {
          handlerState(setModalSaveDataResident)
        }}
        padding="0 1rem 1rem"
      >
        <Modal.Header
          onclick={() => {
            handlerState(setModalSaveDataResident)
          }}
        />
        <Modal.Content
          value="Você deseja salvar?"
          subvalue="Ao clicar em salvar, você estará alterando as informações deste usuário."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => {
              stopEditing()
              handlerState(setModalSaveDataResident)
            }}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              sendUpdate(userData)
              handlerState(setModalSaveDataResident)
            }}
          >
            <Button.Content title="Salvar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      {/* Sucesso */}

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={modalResidentSuccess}
        setIsOpenController={() => {
          handlerState(setModalResidentSuccess)
        }}
        padding="0 1rem 1rem"
      >
        <Modal.Header
          onclick={() => {
            handlerState(setModalResidentSuccess)
          }}
        />
        <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
        <Modal.Content
          value="Dados atualizados!"
          subvalue="O perfil desse usuário foi atualizado."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              handlerState(setModalResidentSuccess)
              // handlerState(() => toggleFunction(handleDataResidentState))
              window.location.reload()
            }}
          >
            <Button.Content title="OK" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
      <Divider />
      <Section>
        <Title>Dados de residência</Title>
        <Select
          onchange={(e) => handleContractChange(e.target.value)}
          name="Contract"
          data={contractOptions}
          currentOption={tempItem.Contract && tempItem.Contract.id}
          label={{
            title: 'Contrato de seguro',
            htmlFor: '',
            color: '',
            fontSize: '12px',
          }}
          // data={''}
          backgroundcolor=""
          bordercolor="#CECECE"
          outlinecolor=""
        />
        {addressList?.map((item, idx) => {
          return (
            <AddressContainer key={'Address' + idx}>
              <TitleLine title={'Endereço ' + (idx + 1)} />
              <Input.Root flex="1">
                <Input.Label title="CEP" htmlFor={'residentCEP' + idx} />
                <Input.Wrapper>
                  <Input.Content
                    id={'residentCEP' + idx}
                    type="text"
                    value={item.zipcode}
                    name="zipcode"
                    mask="cep"
                    required
                    onChange={handleCepChange(idx)}
                  />
                </Input.Wrapper>
              </Input.Root>
              <Row>
                <Input.Root flex="2">
                  <Input.Label
                    title="Endereço"
                    htmlFor={'residentAddress' + idx}
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentAddress' + idx}
                      type="text"
                      name="address"
                      value={item.address}
                      onChange={handleAddressChange(idx)}
                      required
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="2">
                  <Input.Label
                    title="Bairro"
                    htmlFor={'residentDistrict' + idx}
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentDistrict' + idx}
                      type="text"
                      name="burgh"
                      value={item.burgh}
                      onChange={handleAddressChange(idx)}
                      required
                    />
                  </Input.Wrapper>
                </Input.Root>
              </Row>
              <Row>
                <Input.Root flex="2">
                  <Input.Label title="Cidade" htmlFor={'residentCity' + idx} />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentCity' + idx}
                      type="text"
                      name="city"
                      value={item.city}
                      onChange={handleAddressChange(idx)}
                      required
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Select
                  flex="1"
                  onchange={handleAddressChange(idx)}
                  name={'state'}
                  label={{
                    title: 'Estado',
                    htmlFor: '',
                    color: '',
                    fontSize: '12px',
                  }}
                  data={states}
                  backgroundcolor=""
                  bordercolor="#CECECE"
                  currentOption={item.state}
                  outlinecolor=""
                />
              </Row>
              <Select
                onchange={handleAddressChange(idx)}
                name={'id_responsible_base'}
                label={{
                  title: 'Base responsável',
                  htmlFor: '',
                  color: '',
                  fontSize: '12px',
                }}
                data={baseOptions || []}
                currentOption={item.id_responsible_base}
                backgroundcolor=""
                bordercolor=""
                outlinecolor=""
              />
              {/* <Input.Root>
                <Input.Label
                  title="Posto responsável"
                  htmlFor="residentResponsiblePost"
                />
                <Input.Wrapper>
                  <Input.Content
                    id="residentResponsiblePost"
                    type="text"
                    value={editItem.outpost}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root> */}
              {idx === 0 ? null : (
                <>
                  {/* <Select
                    onchange={handleAddressChange(idx)}
                    name={'id_responsible_base'}
                    label={{
                      title: 'Base responsável',
                      htmlFor: '',
                      color: '',
                      fontSize: '14px',
                    }}
                    data={baseOptions || []}
                    backgroundcolor=""
                    bordercolor=""
                    currentOption={item.id_responsible_base}
                    outlinecolor=""
                  /> */}
                  {/* <Input.Root>
                    <Input.Label
                      title="Base responsável"
                      htmlFor={'residentResponsableBase' + idx}
                    />
                    <Input.Wrapper>
                      <Input.Content
                        id={'residentResponsableBase' + idx}
                        name="base"
                        onChange={handleAddressChange(idx)}
                        type="text"
                        required
                      />
                    </Input.Wrapper>
                  </Input.Root> */}
                  {/* <Input.Root>
                    <Input.Label
                      title="Posto responsável"
                      htmlFor={'residentResponsiblePost' + idx}
                    />
                    <Input.Wrapper>
                      <Input.Content
                        id={'residentResponsiblePost' + idx}
                        type="text"
                        name="outpost"
                        onChange={handleAddressChange(idx)}
                        required
                      />
                    </Input.Wrapper>
                  </Input.Root> */}
                  <RemoveButtonContainer>
                    <Button.Root
                      backgroundColor="#770A00"
                      type="button"
                      onClick={() => {
                        handleRemoveAddress(idx)
                      }}
                    >
                      <Button.Content title="Remover endereço" />
                      <Button.Icon>
                        <Trash size={15} fill="white" />
                      </Button.Icon>
                    </Button.Root>
                  </RemoveButtonContainer>
                </>
              )}
            </AddressContainer>
          )
        })}
        <AddButtonContainer>
          <Button.Root
            backgroundColor="#003E5F"
            type="button"
            onClick={handleAddAddress}
          >
            <Button.Content title="Adicionar outro endereço" />
            <Button.Icon>
              <Plus size={15} fill="white" />
            </Button.Icon>
          </Button.Root>
        </AddButtonContainer>
      </Section>
      <Divider />
      <Section>
        <Title>Veículos da residência</Title>
        {vehiclesList?.map((item, idx) => {
          return (
            <AddressContainer key={'Vehicle' + idx}>
              <TitleLine title={'Veículo ' + (idx + 1)} />
              <Select
                flex="1"
                onchange={handleVehicleChange(idx)}
                name={'type'}
                label={{
                  title: 'Tipo do veículo',
                  htmlFor: '',
                  color: '',
                  fontSize: '12px',
                }}
                data={[
                  { id: 'CARRO', value: 'Carro' },
                  { id: 'MOTO', value: 'Moto' },
                ]}
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={item.type}
                outlinecolor=""
              />
              <Row>
                <Input.Root flex="1">
                  <Input.Label
                    title="Veículo do usuário:"
                    htmlFor={'residentVehicleUser' + idx}
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentVehicleUser' + idx}
                      type="text"
                      value={item.vehicle}
                      name="vehicle"
                      onChange={handleVehicleChange(idx)}
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label
                    title="Cor do carro:"
                    htmlFor={'residentVehicleColor' + idx}
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentVehicleColor' + idx}
                      type="text"
                      name="color"
                      value={item.color}
                      onChange={handleVehicleChange(idx)}
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label
                    title="Placa:"
                    htmlFor={'residentVehiclePlate' + idx}
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentVehiclePlate' + idx}
                      type="text"
                      name="plate"
                      value={item.plate}
                      onChange={handleVehicleChange(idx)}
                    />
                  </Input.Wrapper>
                </Input.Root>
              </Row>
              <RemoveButtonContainer>
                <Button.Root
                  backgroundColor="#770A00"
                  type="button"
                  onClick={() => handleRemoveVehicles(idx)}
                >
                  <Button.Content title="Remover veículo" />
                  <Button.Icon>
                    <Trash size={15} fill="white" />
                  </Button.Icon>
                </Button.Root>
              </RemoveButtonContainer>
            </AddressContainer>
          )
        })}
        <AddButtonContainer>
          <Button.Root
            backgroundColor="#003E5F"
            type="button"
            onClick={handleAddVehicles}
          >
            <Button.Content title="Adicionar outro veículo" />
            <Button.Icon>
              <Plus size={15} fill="white" />
            </Button.Icon>
          </Button.Root>
        </AddButtonContainer>
      </Section>
      <Divider />
      <Section>
        <Title>Informações de acesso</Title>
        <TitleLine title={'Acesso usuário principal'} />
        <Input.Root>
          <Input.Label title="Usuário - login" htmlFor="residentUserLogin" />
          <Input.Wrapper>
            <Input.Content
              id="residentUserLogin"
              type="text"
              value={tempItem.login}
              readOnly
            />
          </Input.Wrapper>
        </Input.Root>
        {/* <Input.Root>
          <Input.Label title="Senha de acesso" htmlFor="residentPassword" />
          <Input.Wrapper>
            <Input.Content
              id="residentPassword"
              type={isPasswordShowing ? 'text' : 'password'}
              value={editItem.password}
              readOnly
              // onChange={(e) => setPassword(e.target.value)}
            />
            <Input.Icon onClick={() => toggleFunction(setIsPasswordShowing)}>
              {isPasswordShowing ? (
                <Eye size={14} color="#494949" />
              ) : (
                <EyeSlash size={14} color="#494949" />
              )}
            </Input.Icon>
          </Input.Wrapper>
        </Input.Root> */}
        {tempItem.LinkedUsers.length > 0 ? (
          <>
            <TitleLine title="Usuários cadastrados na residência" />
            {tempItem.LinkedUsers?.map((item, idx) => {
              return (
                <Input.Root key={item.id}>
                  <Input.Label
                    title="Usuário - login"
                    htmlFor={'residentUserLogin' + idx}
                  />
                  <Input.Wrapper>
                    <Input.Content
                      id={'residentUserLogin' + idx}
                      type="text"
                      value={item.login}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
              )
            })}
          </>
        ) : null}
        <ButtonRow>
          <ButtonContainer>
            <Button.Root backgroundColor="#003E5F" type="submit">
              <Button.Content title="Salvar dados" />
            </Button.Root>
          </ButtonContainer>
          <ButtonContainer>
            <Button.Root
              backgroundColor="#770A00"
              type="button"
              onClick={() => {
                disableResident()
                toggleFunction(handleModalDisable)
              }}
            >
              <Button.Content title="Desativar acessos" />
            </Button.Root>
          </ButtonContainer>
        </ButtonRow>
      </Section>
    </Container>
  )
}
